import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../../utils/TableCustomStyles";

function TranshipmentReport() {
  const addform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  

  const [canvasFullScreen, setCanvasFullScreen] = useState(false);
  const [showUpdateProjectNameError, setShowUpdateProjectNameError] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [updateProjectName, setUpdateProjectName] = useState("");
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [deleteRecordId, setDeleteRecordId] = useState(null);

  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);


  const getLoggenInUser = async () => {
      try {
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
          if (response) {
              setLoggedInUser(response.data)
          }
      } catch (err) {
          toast.error("Error in fetching user data! Try again.");
      }
  }

  
  const getProject = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/project/');
        setTimeout(() => {
          if (response) {
              setData(response.data)
              setDataPending(false)
          }
        }, 500);
        
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (row) => {
    setShowDeleteModal(true)
    setDeleteRecordId(row.id)
  }


  useEffect(() => {
    getProject()
    getLoggenInUser()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const get_user = (userjson) => {
    if(!userjson==""){
      const user_data = JSON.parse(userjson)
      return user_data?.name
    }
    else{
      return "None"
    }
    
  }

  const columns = [
    {
      name: 'Project Name',
      selector: row => row.project_name,
      sortable: true,
    },
    {
      name: 'Created By',
      selector: row => get_user(row.created_by),
      sortable: true,
    },
    {
      name: 'Created On',
      selector: row => row.created_on.slice(0,10),
      sortable: true,
    },
    {
      name: 'Action',
      right: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("master:project:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection"
          onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("master:project:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateProjectName(row.project_name)
  }

  const addProject = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    const data = {
          project_name: addform.current.project_name.value,
          created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }
    
    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/project/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Project Created Successfully")
    }

    addform.current.project_name.value = ""
    getProject()
    setShowAddCanvas(false)
    setShowAddLoader(false)
  }

  const updateProject = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)
    const id = updateId

    const data = {
          project_name: updateProjectName,
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }
    
    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/project/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Project Updated Successfully")
    }

    getProject()
    setShowUpdateCanvas(false)
    setShowUpdateLoader(false)
  }

  const deleteProject = async (e) => {
    e.preventDefault();
    setShowDeleteLoader(true)
    const id = deleteRecordId
    
    const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/project/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Project Deleted Successfully")
    }

    getProject()
    setShowDeleteLoader(false)
    setShowDeleteModal(false)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Shipment" activeSubMenu="Transhipments" activeSubMenuLevel1="TranshipmentReport" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Transhipment Report</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
            {
              currentUserRolePermissionData?.includes("master:project:add")?
                <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection">
                  <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                  <span className="fw-bold">Add Project</span>
                </Button>
              :
                ""
            }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={(e) => deleteProject(e)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
              "Delete"
            }
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Upload Project</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>
        <div class="offcanvas-body" style={{ marginLeft: 400 }}>
          <form onSubmit={(e) => updateProject(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-6":"col-md-6"} text-left mb-4`}>
                <label for="name">Project Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateProjectNameError?" Project Name required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="project_name" name="project_name" placeholder="Enter Project Name"
                value={updateProjectName} onChange={(e) => setUpdateProjectName(e.target.value)}
                onBlur={(e) => e.target.value==""?setShowUpdateProjectNameError(true):setShowUpdateProjectNameError(false)}/>
              </div> 

              <div class={`form-group ${canvasFullScreen?"col-md-6":"col-md-6"} text-left mb-4`}>
                <Button className="btn btn-inox-green border-0 canvas-button btn-sm mt-4" onClick={(e) => updateProject(e)}>
                    <i className="fa fa-edit"></i> 
                    <span className="mx-2">
                      {showUpdateLoader?
                      <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Update"
                      }
                    </span>
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Project</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowAddCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>
        <div class="offcanvas-body" style={{ marginLeft: 400 }}>
          <form ref={addform} onSubmit={(e) => addProject(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-6":"col-md-6"} text-left mb-4`}>
                <label for="name">Project Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateProjectNameError?" Project Name required":""}</span></label>
                <input type="text" class="form-control form-control-sm" id="project_name" name="project_name" placeholder="Enter Project Name"
                onBlur={(e) => e.target.value==""?setShowUpdateProjectNameError(true):setShowUpdateProjectNameError(false)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-6":"col-md-6"} text-left mb-4`}>
                <Button className="btn btn-inox-green border-0 canvas-button btn-sm mt-4" onClick={(e) => addProject(e)}>
                    <i className="fa fa-plus"></i> 
                    <span className="mx-2">
                      {showAddLoader?
                      <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Add"
                      }
                    </span>
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default TranshipmentReport;
